'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _BarsOutlined = _interopRequireDefault(require('./lib/icons/BarsOutlined'));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    'default': obj
  };
}

var _default = _BarsOutlined;
exports.default = _default;
module.exports = _default;